import usePermission from "./usePermission";
import useRequestResponse from "./useRequestResponse";
import A from './ActionCreators';
import G from './Getters';
import { useStore, useDispatch } from 'react-redux';

export default function ItemPermissionView({
  itemType,
  itemId,
  action
}){

  const store = useStore();
  const state = store.getState();
  

  const permission = usePermission({
    itemType,
    itemId,
    action
  })

  //let route = `/checkUserActionPermission?itemType=${itemType}&itemId=${itemId}&action=${action}`;
  //let [permission] = useRequestResponse(route);

  debugger;

  let background;
  let { data } = permission || {};
  if( data!==undefined ){
    background = data ? "green" : "red";
  }else{
    background = "white";
  }


  return (
    <div style={{
      //border:'3px solid magenta',
      width:50,
      height:50,
      background,
      border:'2px solid white',
    }}>
      {}
      
    </div>
  )












}
